import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { MatButtonModule } from '@angular/material/button';
import { LySliderModule } from '@alyle/ui/slider';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LyDialogModule } from '@alyle/ui/dialog';
import { CropperDialog } from './cropper-dialog.component';
import { CropperBannerDialog } from './cropper-banner-dialog.component';
import { B2BRoutingModule } from './b2b-routing.module';
import { BecomeAB2BUserComponent } from 'src/app/components/b2b/become-a-b2b-user/become-a-b2b-user.component';
import { B2BCreateShipmentComponent } from 'src/app/components/b2b/b2b-create-shipment/b2b-create-shipment.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { ShippnDateAdapter } from 'src/app/shared/shippnDateAdapter';
import { MatInputModule } from '@angular/material/input';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AddItemForCustomsDialog } from 'src/app/components/b2b/b2b-create-shipment/addItemForCustoms-dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { B2BShipmentListComponent } from 'src/app/components/b2b/b2b-shipments-list/b2b-shipments-list.component';
import { MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { B2BShipmentsDataSource } from 'src/app/services/b2bshipments.service';
import { ChangeSenderInfoDialog } from 'src/app/components/b2b/b2b-create-shipment/change-sender-info-dialog/change-sender-info-dialog';
import { EditItemForCustomsDialog } from 'src/app/components/b2b/b2b-create-shipment/editCustomItemDialog/edit-custom-item-dialog';
import { CreateShipmentErrorDialog } from 'src/app/components/b2b/b2b-create-shipment/create-shipment-error-dialog/create-shipment-error-dialog';
import { PrintInVoiceAndLabelDialog } from 'src/app/components/b2b/b2b-shipments-list/print-invoice-label-dialog/print-invoice-label-dialog';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectSenderInfoDialog } from 'src/app/components/b2b/b2b-create-shipment/select-sender-info-dialog/select-sender-info-dialog';
import { B2BArrangePickupDialog } from 'src/app/features/B2B/b2b-arrange-pickup-dialog/b2b-arrange-pickup-dialog';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { B2BArrangePickupDetailsDialog } from 'src/app/features/B2B/b2b-pickup-details-dialog/b2b-pickup-details-dialog';
import { B2bMainComponent } from 'src/app/components/b2b/b2b-main/b2b-main.component';
import { B2BApiUserComponent } from 'src/app/components/b2b/b2b-api-user/b2b-api-user.component';
import { B2BJsonTreeComponent } from 'src/app/features/B2B/b2b-json-tree/b2b-json-tree.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import {B2BPickupsComponent} from '../../components/b2b/b2b-pickups/b2b-pickups.component';
import { B2BApiSchedulePickupDialog } from 'src/app/features/B2B/b2b-api-schedule-pickup-dialog/b2b-api-schedule-pickup-dialog';
import { B2BCreateShipmentOldComponent } from 'src/app/components/b2b/b2b-create-shipment-old/b2b-create-shipment-old.component';
import { CustomPSMService } from 'src/app/services/custompasswordstrength.service';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';

@NgModule({
  declarations: [
    B2bMainComponent,
    BecomeAB2BUserComponent,
    B2BCreateShipmentComponent,
    B2BShipmentListComponent,
    CropperDialog,
    CropperBannerDialog,
    AddItemForCustomsDialog,
    EditItemForCustomsDialog,
    ChangeSenderInfoDialog,
    SelectSenderInfoDialog,
    CreateShipmentErrorDialog,
    PrintInVoiceAndLabelDialog,
    EditItemForCustomsDialog,
    B2BArrangePickupDialog,
    B2BArrangePickupDetailsDialog,
    B2BApiUserComponent,
    B2BJsonTreeComponent,
    B2BPickupsComponent,
    B2BApiSchedulePickupDialog,
    B2BCreateShipmentOldComponent
  ],
  imports: [
    ScrollingModule,
    CommonModule,
    B2BRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    LyImageCropperModule,
    LySliderModule,
    LyButtonModule,
    LyIconModule,
    LyDialogModule,
    NgxCaptchaModule,
    SharedModule,
    NgxMatTimepickerModule,
    MatStepperModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatMenuModule,
    MatRadioModule,
    MatDialogModule,
    NgxPayPalModule,
    MatSortModule,
    MatPaginatorModule,
    NgbModule,
    NgxJsonViewerModule,
    MatStepperModule,
    PasswordStrengthMeterModule
  ],
  providers: [
    B2BShipmentsDataSource,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class B2BModule { }

